import {
  DateTime,
} from 'luxon';

/**
 *
 * @param years_count
 *
 * @returns {Array}
 */
export function getLastYears(years_count) {
  const result = [];
  const current_year = new Date().getFullYear();

  for (let i = current_year; i > current_year - years_count; i -= 1) {
    result.push(i);
  }

  return result;
}

/**
 *
 * @param date
 *
 * @returns {DateTime}
 */
export function getLuxonDate(date, options = {}) {
  if (!date) {
    return null;
  }

  if (date instanceof Date) {
    return DateTime.fromJSDate(date, options);
  }

  if (typeof date === 'string') {
    return DateTime.fromISO(date, options);
  }

  return null;
}
